export function getInTuchNew() {
    const listMap = $(".new_map_offices__list-map li");

    listMap.on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        if(!$this.hasClass("active")){
            let $dataClass = $this.data("class");
            $(".new_map_offices__list-map li.active").removeClass("active");
            $this.addClass("active");
            $(".new_map_offices__box.active").removeClass("active");
            $(".new_map_offices__box" + $dataClass).addClass("active");
        }

    });
    $(".new_map_offices__list li").on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        let $dataClass = $this.data("class");
        if(!$this.hasClass("active")){
            $(".new_map_offices__list li.active").removeClass("active");
            $this.addClass("active");
            $(".new_map_offices__tab.active").removeClass("active");
            $(".new_map_offices__tab" + $dataClass).addClass("active");
        }
    });

    $("#select_region").on("change", function (e) {
        let $this = $(this).val();
        $(".media-contacts__tabs.active").removeClass("active");
        $(".media-contacts__tabs" + $this).addClass("active");

    });


}


// WEBPACK FOOTER //
// ./assets/js/modules/get-in-tuch-new.js